/**
 * Asset publishing status
 */
export enum AssetPublishingStatus {
  PUBLISHED = 'Published',
  UNPUBLISHED = 'Unpublished',
  PLANNED = 'Planned',
  NOT_SET = 'Not set',
}
